import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/element.js'
import apis from '@/apis/index'
import axios from '@/utils/request'
import dayjs from 'dayjs'
import config from '../config'
import qs from 'qs'
import './assets/theme/index.css'
import './assets/css/reset.scss'
import './assets/css/common.scss'
import './assets/iconfont/iconfont.css'
import CustomAction from './components/CustomActions.vue'
import ImageViewer from './components/ImageViewer.vue'
import globalMethods from '@/utils/globalMethods' // 定义全局methods
import FileUpload from './components/FileUpload.vue'

Vue.config.productionTip = false
Vue.prototype.$apis = apis
Vue.prototype.$axios = axios
Vue.prototype.$config = config
Vue.prototype.$dayjs = dayjs
Vue.prototype.$qs = qs
Vue.component(CustomAction.name, CustomAction)
Vue.component('ImageViewer', ImageViewer)
Vue.component(FileUpload.name, FileUpload)
Vue.use(globalMethods)

// 自定义权限指令
Vue.directive('visible', {
  bind (el, binding) {
    if (!store.state.buttonList.some(item => binding.value === item.butCode)) {
      el.style.display = 'none'
    }
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
